// ToastContext.tsx
import React, { createContext, useContext, useState } from 'react';

type Toast = {
  id: number;
  message: string;
};

const ToastContext = createContext<(message: string) => void>(() => {});

export const useToast = () => useContext(ToastContext);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  // const showToast = useCallback((message: string) => {
  //   const id = Date.now();
  //   setToasts((prev) => [...prev, { id, message }]);
  //   setTimeout(() => {
  //     setToasts((prev) => prev.filter((t) => t.id !== id));
  //   }, 3000);
  // }, []);

  const showToast = (message: string) => {
    const id = Date.now();
    setToasts([{ id, message }]); // 항상 새로운 것만!
    setTimeout(() => {
      setToasts([]);
    }, 3000);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed bottom-[21px] left-1/2 z-50 w-[calc(100%-40px)] max-w-md -translate-x-1/2 transform space-y-2">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className="animate-fade-in-out h-[48px] w-full rounded-full bg-[#222222] px-6 py-3 text-center text-[16px] font-normal text-white opacity-90 shadow-lg"
          >
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
